import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8.1 21.212A9.733 9.733 0 0 0 12 22a9.733 9.733 0 0 0 3.9-.788 10.092 10.092 0 0 0 3.175-2.137c.9-.9 1.612-1.958 2.137-3.175A9.733 9.733 0 0 0 22 12a9.733 9.733 0 0 0-.788-3.9 10.092 10.092 0 0 0-2.137-3.175c-.9-.9-1.958-1.613-3.175-2.138A9.743 9.743 0 0 0 12 2a9.743 9.743 0 0 0-3.9.787 10.105 10.105 0 0 0-3.175 2.138c-.9.9-1.612 1.958-2.137 3.175A9.732 9.732 0 0 0 2 12a9.74 9.74 0 0 0 .788 3.9 10.091 10.091 0 0 0 2.137 3.175c.9.9 1.958 1.612 3.175 2.137ZM17.65 9.55 10.6 16.6l-4.25-4.25 1.4-1.4 2.85 2.85 5.65-5.65 1.4 1.4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }